import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Loader2, CheckCircle, XCircle, ArrowLeft } from 'lucide-react';

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { api } = useAuth();
  const [status, setStatus] = useState('loading');
  const [data, setData] = useState(null);

  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (!sessionId) {
      setStatus('error');
      return;
    }
    api.get(`/checkout/status/${sessionId}`)
      .then(res => {
        setData(res.data);
        setStatus(res.data.payment_status === 'paid' ? 'paid' : 'pending');
      })
      .catch(() => setStatus('error'));
  }, [sessionId, api]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-8">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center space-y-4">
          {status === 'loading' && (
            <>
              <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto" />
              <p className="text-lg font-medium">Проверяем оплату...</p>
            </>
          )}
          {status === 'paid' && (
            <>
              <CheckCircle className="h-16 w-16 text-emerald-500 mx-auto" />
              <h2 className="text-2xl font-bold text-emerald-600">Оплата получена!</h2>
              <p className="text-muted-foreground">
                Сумма: {data?.amount_total ? `$${(data.amount_total / 100).toFixed(2)}` : 'Подтверждена'}
              </p>
            </>
          )}
          {status === 'pending' && (
            <>
              <Loader2 className="h-16 w-16 text-amber-500 mx-auto" />
              <h2 className="text-2xl font-bold text-amber-600">Обработка платежа</h2>
              <p className="text-muted-foreground">Платёж обрабатывается. Статус обновится автоматически.</p>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle className="h-16 w-16 text-red-500 mx-auto" />
              <h2 className="text-2xl font-bold text-red-600">Ошибка</h2>
              <p className="text-muted-foreground">Не удалось проверить статус платежа.</p>
            </>
          )}
          <Button variant="outline" onClick={() => navigate('/orders')} className="mt-4" data-testid="back-to-orders-btn">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Вернуться к заказам
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
